<template>
	<div>
	    <b-modal ref="modal_compta" hide-footer>
            <template v-slot:modal-title>
                {{ $t('invoice.selection_compta') }}
            </template>

            <b-alert show variant="warning" class="mt-1">
                {{ $t('invoice.alert_multi_compta_send') }}
            </b-alert>

            <e-select
                track-by="tiers_id"
                label="tiers_rs"
                :placeholder="$t('invoice.select_compta')"
                :options="authors"
                v-model="author_selected"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
            >
            </e-select>

        	<div class="text-center mt-2">
				<b-button variant="primary" :disabled="!author_selected" @click="nextAuthorSelected"><font-awesome-icon :icon="['fal', 'long-arrow-right']" /> {{ $t("global.continuer") }}</b-button>
        	</div>
	    </b-modal>
		<b-modal ref="modal" size="xl" hide-footer @hidden="skip">
			<template v-slot:modal-title>
				<template>
					{{ $t("action.envoyer") }}
				</template>
			</template>

			<LoadingSpinner v-if="loading" />
            <LoadingSpinner v-else-if="processing" class="col-12" text_trad="invoice.preparation_envoi" />
			<div class="row" v-else>
				<div class="col">
					<div class="row">
						<div class="col-12">
			        		<table class="table b-table table-striped table-hover border rounded mb-2">
			        			<thead class="sticky">
			        				<tr>
			        					<th>{{ $t('invoice.tiers_invoice') }}</th>
			        					<th>{{ $t('invoice.tiers_mai') }}</th>
			        					<th>{{ $t('invoice.contacts') }}</th>
			        				</tr>
								</thead>
								<tbody>
									<tr v-for="tier in tiers" :key="tier.tiers_id">
										<td><router-link :to="{ name: 'tiersFiche', params: { tiers_id: tier.tiers_id }}">{{ tier.tiers_rs }}</router-link> <i>{{ tier.tiers_lang }}</i></td>
										<td>
											<div class="d-flex form-group">
												<b-form-checkbox v-model="tier.tiers_mail_selected" :disabled="!tier.tiers_mail"></b-form-checkbox>
												<span v-if="tier.tiers_has_mail">{{ tier.tiers_mail }}</span>
												<b-input v-else v-model="tier.tiers_mail" type="email" />
											</div>
										</td>
										<td class="d-flex">
											<template v-for="contact in tier.contacts">
												<b-form-checkbox
													v-if="contact.contact_mail"
													:key="contact.contact_id"
													v-model="contact.contact_mail_selected"
													class="ml-1"
												>
													{{ contact.contact_mail }}
												</b-form-checkbox>
											</template>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<label for="destinataire">{{ $t('invoice.ajouter_destinataire') }}</label>
						</div>
						<div class="col-8">
							<b-input id="destinataire" v-model="destinataire" type="email" />
							<small>{{ $t('invoice.destinatire_virgule') }}</small>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-4">
							<label for="model_id">{{ $t('invoice.model_notification') }} *</label>
						</div>
						<div class="col">
							<e-select
								v-model="template"
								id="model_id"
								track-by="model_label"
								label="model_label"
								:placeholder="$t('horse.search_doc')"
								:deselectLabel="$t('global.press_enter_to_remove')"
								:selectedLabel="$t('global.selected_label')"
								:options="templates"
								:searchable="true"
								:allow-empty="false"
								:show-labels="false"
								group-values="templates"
			                    group-label="templategroup_label"
			                    :group-select="false"
			                    :class="{ 'is-invalid': template_error }"
								@input="setModel"
							>
								<template slot="singleLabel" slot-scope="{ option }">{{ option.model_label }}</template>
								<template slot="noOptions">{{ $t('global.list_empty') }}</template>
							</e-select>
						</div>
						<div v-if="template" class="col-2">
							<a href="#" @click.prevent="showModel"><font-awesome-icon :icon="['fas', 'eye']" /> {{ $t('invoice.preview_baf.title') }}</a>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-4">
							<label for="expeditor">{{ $t('invoice.expediteur') }}</label>
						</div>
						<div class="col-8">
							<e-select
								id="expeditor"
								:placeholder="$t('model.search_expeditor')"
								:options="expeditors"
								v-model="expeditor"
								:searchable="true"
								:allow-empty="false"
								:show-labels="false"        
							>
								<template slot="singleLabel" slot-scope="{ option }">{{ option }}</template>
								<template slot="noOptions">{{ $t('global.list_empty') }}</template>
							</e-select>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<b-form-checkbox
								id="send_to_sender"
								v-model="send_to_sender"
								:value="true"
								:unchecked-value="false"
							>
								{{ $t("monte.envoie_mail_sender") }}
							</b-form-checkbox>
						</div>
						<div class="col-12">
							<div class="from-group">
								<label for="commentaire" class="col-form-label">{{ $t("monte.commentaire") }}</label>
								<textarea id="commentaire" class="form-control" rows="3" v-model="commentaire"></textarea>
							</div>
						</div>
					</div>
				</div>
				<div v-if="show_model" class="col-12 col-lg-6">
					<template v-if="model_selected.length > 0">
						<div v-for="(model, key) in model_selected" class="border-2 px-3 py-3" v-html="model" :key="key"></div>
					</template>
					<LoadingSpinner v-else class="col-12" />
				</div>
			</div>
	        <div v-if="!processing" class="row border-top mt-2 pt-2">
	        	<div class="col-6">
	        		<a href="" @click.prevent="skip">{{ $t('invoice.skip_etape') }}</a>
	        	</div>
	        	<div class="col-6 text-right">
	        		<b-button variant="primary" rounded @click="submit">{{ $t('invoice.send_invoice_destinataires') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" /></b-button>
	        	</div>
	        </div>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
	import Contact from '@/mixins/Contact.js'
	import Invoice from '@/mixins/Invoice.js'
	import Model from "@/mixins/Model.js"
	import _groupBy from 'lodash/groupBy'
	import Vue from 'vue'

	export default {
		name: 'ModalSendInvoice',
		mixins: [Contact, Invoice, Model],
		props: [],
		data () {
			return {
				authors: [],
				author_selected: null,
				invoices: [],
				tiers: [],
				destinataire: '',
				template: null,
				templates: [],
				expeditor: null,
				expeditors: [],
				send_to_sender: false,
				commentaire: '',
				processing: false,
				loading: false,
				template_error: false,
				model_selected: [],
				show_model: false
			}
		},

		methods: {
			openModal(invoices) {
				this.invoices = invoices
				const invoices_grouped = _groupBy(invoices, 'invoice_accountingplan')
				if(Object.keys(invoices_grouped).length > 1) {
					this.authors = Object.values(invoices_grouped).map(group => group[0].author)
					this.$refs.modal_compta.show()
				}
				else {
					this.loadModal(invoices)
				}
			},
			nextAuthorSelected() {
				this.$refs.modal_compta.hide()
				const invoices = this.invoices.filter(invoice => invoice.author.tiers_id == this.author_selected.tiers_id)
				this.loadModal(invoices)
			},
			async loadModal(invoices) {
				this.$refs.modal.show()
				this.loading = true
				this.invoices = invoices
				this.model_selected = []
				this.show_model = false

				const tiers = {}
				for(let i in invoices) {
					const invoice = invoices[i]
					if(!Object.prototype.hasOwnProperty.call(tiers, invoice.invoice_tiers)) {
						let contacts = await this.getContactByTiersAndByFonction(invoice.invoice_tiers, 'COMPTA', false)
						contacts = contacts.map(contact => ({
							contact_id: contact.contact.contact_id,
							contact_mail: contact.contact.contact_mail,
							contact_mail_selected: !!contact.contact.contact_mail
						}))

						tiers[invoice.invoice_tiers] = {
							'tiers_id': invoice.invoice_tiers,
							'tiers_rs': invoice.tiers.tiers_rs,
							'tiers_mail': invoice.tiers.tiers_mail,
							'tiers_has_mail': !!invoice.tiers.tiers_mail,
							'tiers_mail_selected': !!invoice.tiers.tiers_mail,
							'tiers_lang': invoice.tiers.tiers_lang,
							'contacts': contacts,
							'invoices': []
						}
					}

					tiers[invoice.invoice_tiers].invoices.push(invoice)
				}
				this.tiers = Object.values(tiers)

				const invoice_templates = await this.loadAllModel(this.invoices[0].invoice_accountingplan, ['accounting_plan'], 'invoice_notification')
				let templates = [{
						templategroup_label: this.$t('compta.facture_notif'),
						templates: invoice_templates
				}]

				const unpaid_templates = await this.loadAllModel(this.invoices[0].invoice_accountingplan, ['accounting_plan'], 'unpaid_invoice_notification')
				templates.push({
					templategroup_label: this.$t('compta.relance_notif'),
					templates: unpaid_templates
				})
				this.templates = templates

				this.destinataire = ''
				this.template = null
				this.expeditor = null
				this.send_to_sender = false

				const from_address = await this.loadAllFromAddress()
				this.formatFromAdresse(from_address)

				this.loading = false
			},
			async formatFromAdresse(from_address){
				let array_mail = []
				let array_name = []
				this.expeditors = []
				from_address = Object.values(from_address).filter(from => from.licenceconfig_value)
				const hasValidLicenceKey = from_address.filter(item => item.licenceconfig_licencekey !== null && (item.licenceconfig_key === "from_address" || item.licenceconfig_key === "from_name"))

				if (hasValidLicenceKey.length > 0) {
					from_address = hasValidLicenceKey
				}

				for (let address of from_address) {				
					if (address.licenceconfig_key === "from_address"){
						if (address.licenceconfig_value != '' || address.licenceconfig_value != null){
							const configValueAddress = address.licenceconfig_value.split(',')
							for (const address of configValueAddress){
								array_mail.push(address.trim())
							}
						} 					
					}
					if (address.licenceconfig_key === "from_name") {
						if (address.licenceconfig_value != '' || address.licenceconfig_value != null){
							const configValueName = address.licenceconfig_value.split(',')
							for (const name of configValueName){
								array_name.push(name.trim())
							}
						} 
					}
				}

				for (const index in array_mail){
					this.expeditors.push(array_mail[index]+ " / " + array_name[index])
				}
				this.expeditor = this.expeditors[0]
			},
			skip() {
				this.$refs.modal.hide()
				this.$emit('submit')
			},
			async submit() {
				this.template_error = false
				if(!this.template) {
					this.template_error = true
					return false
				}
				this.processing = true
				const invoices_send = []
				this.tiers.forEach(tier => {
					const mails = []
					if(tier.tiers_mail_selected && tier.tiers_mail) {
						mails.push({
							tiers: true,
							mail: tier.tiers_mail
						})
					}

					tier.contacts.forEach(contact => {
						if(contact.contact_mail_selected) {
							mails.push({
								tiers: false,
								mail: contact.contact_mail
							})
						}
					})

					if(this.destinataire) {
						const destinataires = this.destinataire.split(',')
						destinataires.forEach(destinataire => {
							mails.push({
								tiers: false,
								mail: destinataire
							})
						})
					}

					tier.invoices.forEach(invoice => {
						mails.forEach(mail => {
							invoices_send.push({
								invoicesend_invoice: invoice.invoice_id,
								invoicesend_date: invoice.invoice_date,
								invoicesend_model: this.template.model_id,
								invoicesend_recipient: mail.mail,
								invoicesend_sender: this.expeditor,
								invoicesend_send_to_sender: this.send_to_sender,
								invoicesend_commentaire: this.commentaire,
								update_mail_tiers: mail.tiers && !tier.tiers_has_mail ? tier.tiers_id : null
							})
						})
					})
				})

				if(invoices_send.length == 0) {
					this.processing = false
					this.infoToast('invoice.no_email_selected')
					return false
				}

				await this.sendInvoice(invoices_send)
				.then((res) => {
					this.processing = false
					this.successToast('monte.send_success_invoice')
					this.$emit('submit')
					this.skip()
				})
			},
			async setModel() {
				this.model_selected = []

				if(this.template) {
					const all_lang = [...new Set(this.tiers.map(t => t.tiers_lang))]
					const models = await this.loadModel(this.invoices[0].invoice_accountingplan, this.template.model_id, 'accounting_plan')

					for(let i in all_lang) {
						const templates = await this.loadTemplate(this.invoices[0].invoice_accountingplan, this.template.model_id, 'accounting_plan', all_lang[i])
						const zone = models[0].zone.find(zone => zone.zonetype.modelzonetype_code.includes('_body'))
						const template = templates.find(temp => temp.modeltemplate_modelzone == zone.modelzone_id).modeltemplate_content
						this.model_selected.push(template)
					}
				}
			},
			showModel() {
				this.show_model = true
				let modal = document.getElementsByClassName('modal-dialog')[0]
				modal.classList.add('modal-xxl')
			},
		},
		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
		}
	}

</script>